import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import filesize from 'filesize';
import { currentUploadsComplete, continueUpload, stopUpload, toggleIsCancelDownloadDialogOpen, uploadsComplete, uploadsInProgress } from '../actions/upload-actions';
import { requestAlbum } from '../../album-view/actions/album-actions';

import { Dialog } from '../../common/components/dialog';
import { FileUploadPauseContent } from './dialog/file-upload-pause-upload-content';
import { pauseUpload, clearUploads } from '../../uploadController/actions/uploadController-actions';


class FileUploadProgress extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			uploadStarted: false,
			uploadComplete: false,
			isUploading: false,
			lastComplete: -1,
            isCancelDownloadDialogOpen:false
		};

		this.uploadsComplete = this.uploadsComplete.bind(this);
		this.uploadsStarted = this.uploadsStarted.bind(this);
		this.handleWindowUnload = this.handleWindowUnload.bind(this);
		this.getBytesPerSecond = this.getBytesPerSecond.bind(this);
		this.getByteStatus = this.getByteStatus.bind(this);
		this.getFileProgress = this.getFileProgress.bind(this);
		this.getTimeToComplete = this.getTimeToComplete.bind(this);
		this.getUploadSpeed = this.getUploadSpeed.bind(this);
		this.openCancelDownloadDialog = this.openCancelDownloadDialog.bind(this);
		this.closeCancelDownloadDialog = this.closeCancelDownloadDialog.bind(this);
		this.stopUploads = this.stopUploads.bind(this);
		this.continueUploads = this.continueUploads.bind(this);
		
	}

	componentDidMount() {
		window.addEventListener('beforeunload', this.handleWindowUnload);
	}

	componentDidUpdate(prevProps, prevState) {

		if (!prevProps.uploadsStarted && this.props.uploadsStarted) {
			this.uploadsStarted();
		}

		if (this.getFileProgress() >= 100 && !this.props.filesToUpload.size) {
			this.props.setUploadsComplete();
			//this.setState({ uploadComplete: true });
			this.uploadsComplete();
		} 
		

		else if (!prevProps.uploadComplete & this.props.uploadComplete) {
			
			this.uploadsComplete();
		}
		else if (this.props.uploadComplete) {
			this.props.setUploadsInProgress();
		//	this.setState({ uploadComplete: false });
		}
	}

	componentWillUnmount() {}

	openCancelDownloadDialog() {
		this.props.pauseUpload();
		this.props.toggleIsCancelDownloadDialogOpen();
		
	}

	closeCancelDownloadDialog() {
		this.props.toggleIsCancelDownloadDialogOpen();
       
	}

	handleWindowUnload(evt) {
		if (this.props.uploadStarted && !this.props.uploadComplete) {
			evt.returnValue = 'There are uploads in progress. Are you sure that you want to leave?';
		}
	}

	uploadsComplete() {
		if (this.props.onUploadComplete) {
			this.props.onUploadComplete();
		}

		window.removeEventListener('beforeunload', this.handleWindowUnload);

	//	const { requestAlbum } = this.props;
	
	}

	uploadsStarted() {
	
		if (this.props.uploadsStarted) {
			this.props.uploadStarted();
		}
	}

	getFileProgress() {
		const allFileQueues = [
			...this.props.filesToUpload
		];
const totalComplete = this.props.completeUploads;
		if (!allFileQueues.length) {
			return 0;
		}

		let totalProgress = 0;
	

		totalProgress = Math.round((totalComplete.length / allFileQueues.length)*100);
		
		return totalProgress;
	}

	getByteStatus(fileList) {
		const allFileQueues = [
			...this.props.filesToUpload
		];

		if (!fileList.length) {
			return `${filesize(0)} / ${filesize(0)}`;
		}

		let totalBytes = 0;
		let loadedBytes = 0;

		allFileQueues.forEach(file => {
			if (file.size) {
				totalBytes += file.size;
			}
			if (file.progressStats) {
				loadedBytes += file.progressStats.loaded;
			}
		});

		return `${filesize(loadedBytes)} / ${filesize(totalBytes)}`;
	}

	getFileProgress2(fileList) {
		const allFileQueues = [
			...this.props.filesToUpload
		];

		if (!fileList.length) {
			return `0`;
		}

		let totalBytes = 0;
		let loadedBytes = 0;

		allFileQueues.forEach(file => {
			if (file.size) {
				totalBytes += file.size;
			}
			if (file.progressStats) {
				loadedBytes += file.progressStats.loaded;
			}
		});
       
		const totalProgress = Math.round((1-(totalBytes - loadedBytes)/totalBytes)*100);
		
		return `${totalProgress}`;
	}

	getBytesPerSecond(fileList, started) {
		const timeDifferenceInSeconds = new Date(Date.now() - started).getTime() / 1000;
		
		
		let loadedBytes = 0;
		fileList.forEach(file => {
			
			
			if (file.progressStats) {
				loadedBytes += file.progressStats.loaded;
			}
		});

		
		const bytesPerSecond = loadedBytes / timeDifferenceInSeconds;
		
		
		return isNaN(bytesPerSecond) ? 0 : bytesPerSecond;
	}

	getUploadSpeed(fileList, started) {
		if (!fileList.length) {
			return filesize(0);
		}

		const bytesPerSecond = this.getBytesPerSecond(fileList, started);

		return filesize(isNaN(bytesPerSecond) ? 0 : bytesPerSecond);
	}

	getTimeToComplete(fileList, started) {
		const bytesPerSecond = this.getBytesPerSecond(fileList, started);
		const zeroTime = moment(new Date(0, 0, 1, 0, 0, 0)).format('HH:mm:ss');

		if (!fileList.length || isNaN(bytesPerSecond)) {
			return zeroTime;
		}

		let totalBytes = 0;
		let loadedBytes = 0;
		fileList.forEach(file => {
			totalBytes += file.size;
			if (file.progressStats) {
				loadedBytes += file.progressStats.loaded;
			}
		});

		if (loadedBytes === 0) {
			return zeroTime;
		}

		let timeRemaining = (totalBytes - loadedBytes) / bytesPerSecond;
		if (isNaN(timeRemaining)) {
			timeRemaining = 0;
		}

		return moment(new Date(0, 0, 0, 0, 0, timeRemaining)).format('HH:mm:ss');
	}

	stopUploads() {
		this.props.toggleIsCancelDownloadDialogOpen();
		//this.setState({isCancelDownloadDialogOpen:false,
		//	uploadComplete: true});
		this.props.clearUploads();
		this.props.stopUpload();

	}

	continueUploads() {
		this.props.pauseUpload();
		this.closeCancelDownloadDialog();
	}

	render() {
	//	const fileProgress = this.getFileProgress();
		//console.log('file progress', fileProgress);

		const allFileQueues = [
			...this.props.filesToUpload
		];

		if (!allFileQueues.length) {
			return <span />;
		}
const fileProgress = this.getFileProgress2(allFileQueues);
		const pauseResumeButtons = this.props.uploadComplete ? (
			<span />
		) : (
			<div className="upload-pause-container">
				<button
					className={this.props.uploadActive ? 'btn-upload-pause' : 'hidden'}
					onClick={this.openCancelDownloadDialog}
					alt="Pause">
					Stop Upload
				</button>
				
			</div>
		);

		return (
			<div className="upload-overall-progress-section">
				<h2>Current Progress</h2>
				<div className="upload-overall-progress-container">
					<div className="upload-overall-progress-label label-space-1 upload-overall-progress-files">
                        {this.props.completeUploads.length} of {allFileQueues.length}
					</div>
					|
					<div className="upload-overall-progress-label label-space-2 upload-overall-progress-time">
						{this.props.uploadStop? "Complete" : this.getTimeToComplete(allFileQueues, this.props.uploadStarted)}
					</div>
					|
					<div className="upload-overall-progress-label label-space-2 upload-overall-progress-percent">{fileProgress}%</div>
					|
					<div className="upload-overall-progress-label label-space-2 upload-overall-progress-size">
						{this.getByteStatus(allFileQueues)}
					</div>
                    <div className="upload-overall-progress-label label-space-1 upload-overall-progress-speed">
						( {this.getUploadSpeed(allFileQueues, this.props.uploadStarted)}/s )
                    </div>
				</div>
				<div className="upload-progress-container">
					<div className="upload-progress">
						<span className="upload-progress-fill" style={{ width: `${fileProgress}%` }} />
					</div>
				</div>
				{pauseResumeButtons}
				
			</div>
		);
	}
}

FileUploadProgress.propTypes = {
	filesToUpload: PropTypes.array,
	uploadStarted: PropTypes.number,
	uploadsStarted: PropTypes.func,
	onUploadComplete: PropTypes.func,
	allFileQueues: PropTypes.array,
	completeUploads: PropTypes.array,
	uploadActive: PropTypes.bool,
	requestAlbum: PropTypes.func,
	pauseUpload: PropTypes.func,
	continueUpload: PropTypes.func,
	clearUploads: PropTypes.func,
	uploadStop: PropTypes.bool,
	stopUpload: PropTypes.func,
	restartUpload: PropTypes.func,
	isCancelDownloadDialogOpen: PropTypes.bool,
	toggleIsCancelDownloadDialogOpen: PropTypes.func,
	uploadComplete: PropTypes.bool,
	setUploadsComplete: PropTypes.func,
	setUploadsInProgress: PropTypes.func

};

const mapStateToProps = state => {
	return {
		
		uploadStarted: state.uploadController.uploadStarted,
		
	
		uploadActive: state.upload.uploadActive,
		uploadStop: state.upload.uploadStop,
		isCancelDownloadDialogOpen: state.upload.isCancelDownloadDialogOpen,
		uploadComplete: state.upload.uploadComplete
	};
};
	
const mapDispatchToProps = dispatch => {
	return {
		uploadsComplete: () => dispatch(currentUploadsComplete()),
		requestAlbum: albumId => dispatch(requestAlbum(dispatch, albumId)),
		pauseUpload: () => dispatch(pauseUpload()),
		continueUpload: () => dispatch(continueUpload()),
		stopUpload: () => dispatch(stopUpload()),

		setUploadsComplete: () => dispatch(uploadsComplete()),
		setUploadsInProgress: () => dispatch(uploadsInProgress()),

		
		toggleIsCancelDownloadDialogOpen: () => dispatch(toggleIsCancelDownloadDialogOpen()),

		

		clearUploads: () => {
			dispatch(clearUploads());
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(FileUploadProgress);



// WEBPACK FOOTER //
// ./src/upload/components/file-upload-progress.jsx